export default __webpack_public_path__ + "static/media/home-dark-theme.19625e7d.png";